"use client";

import { Button } from "@/components/buttons/Button";
import { Image } from "@/components/Image";
import { Logo } from "@/components/Logo";

interface CoverPageProps {
    onClick: () => void;
}

export default function CoverPage({ onClick }: CoverPageProps) {
    return (
        <div className="flex-1 flex flex-col items-center justify-center gap-16 h-full">
            <div className="flex flex-col items-center justify-center gap-8">
                <Logo
                    variant="col"
                    logoSize={75}
                    fontSize="45px"
                    lineHeight="38px"
                />
                <h3
                    style={{
                        textAlign: "center",
                        fontSize: "20px",
                        color: "var(--primary-color)",
                    }}
                >
                    כשחדשנות פוגשת
                    <br />
                    סביבה וחינוך בקהילה.
                </h3>
            </div>
            <div className="flex items-center justify-center max-w-[85%] h-[fit-content]">
                <Image
                    src={
                        process.env.NEXT_PUBLIC_WELCOME_IMAGE_URL ||
                        "/images/kids.jpg"
                    }
                    className="max-h-[45dvh]"
                    alt="welcome"
                    rounded
                />{" "}
            </div>
            <Button variant="primary" onClick={onClick}>
                כניסה
            </Button>
        </div>
    );
}
